import React, { useEffect, useState } from 'react';
import Switch from "react-switch";
import { GuardarCarrLog } from '../../funciones/PreferenciasAdminFunction';
import { NotificationManager } from 'react-notifications';

const CarrerasUsu = (props) => {
    const [switchVal, setSwitchVal] = useState(props.data.log_status);
    const [icon, setIcon] = useState({class: "fa fa-circle", color: "#424224"});

    const styles = {
        padding: 5, fontSize: 12
    }

    let cambiaSw = () => {
        setIcon({class: "fa fa-circle-o-notch fa-spin", color: "#424224"});
        setSwitchVal(!switchVal);

        let mess = "ACTIVADO";
        if(switchVal === true) mess = "DESACTIVADO";

        GuardarCarrLog(props.data.id, !switchVal, () => {
            setIcon({class: "fa fa-check", color: "#3f773f"});
            NotificationManager.success(`Se ha ${mess} el inicio de sesión para ${props.data.carrera_name}`);
        })
    }

    return(
        <React.Fragment>
            <tr>
                <td align="left" style={styles}>{props.data.carrera_name}</td>
                <td align="center" style={styles}>
                    <Switch
                        offColor = "#bf4848"
                        onHandleColor = "#fff"
                        onColor = "#5cb85c"
                        offHandleColor = "#fff"
                        checked = {switchVal}
                        onChange = {cambiaSw} 
                        checkedIcon = { <div style = {{minWidth: 90, marginLeft: 10, paddingTop: 8, fontWeight: "bold", color: "#FFF", fontSize: 10}}>ACTIVADO</div> }
                        uncheckedIcon = { <div style = {{minWidth: 90, marginLeft: -25, paddingTop: 8, color: "#FFF", fontWeight: "bold", fontSize: 9}}>DESACTIVADO</div> }
                        className = "react-switch" height = {30} width = {100}
                    />    
                </td>
                <td align = "center" width = {25} style={styles}>
                    <i className = {icon.class} style = {{color: icon.color}}></i>
                </td>
            </tr>
        </React.Fragment>
    )
}

export default CarrerasUsu;


// WEBPACK FOOTER //
// ./src/views/Opciones/CarrerasUsu.jsx